var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardnetinterestmargin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1125 3.9209H26.9999V34.9307H34.1125V3.9209Z",
    fill: "#FF7224"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5561 19.4258H26.9999V34.9307H30.5561V19.4258Z",
    fill: "#FF9755"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.112 3.9209H30.5558V19.4258H34.112V3.9209Z",
    fill: "#DB6000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9697 12.8308H3.85706V34.9308H10.9697V12.8308Z",
    fill: "#FFD67A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41325 23.8809H3.85706V34.9308H7.41325V23.8809Z",
    fill: "#FFE29E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.97 12.8308H7.41376V23.8808H10.97V12.8308Z",
    fill: "#FBB500"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6973 8.37585H15.5847V34.9308H22.6973V8.37585Z",
    fill: "#75EF84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1409 21.653H15.5847V34.9301H19.1409V21.653Z",
    fill: "#B7FFB9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6968 8.37585H19.1406V21.653H22.6968V8.37585Z",
    fill: "#3AB94B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 36H0V0H2.1387V33.8613H35.9999V36Z",
    fill: "#C23700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardnetinterestmargin);
export default __webpack_public_path__ + "static/media/dashboardnetinterestmargin.7b143f28a9bffdaf49c9c3672130e81d.svg";
export { ForwardRef as ReactComponent };